import moment, { MomentInput } from 'moment';
import translations from 'translations';
import messages from './messages';

export const getDateText = (date?: MomentInput) => {
  const convertedDate = moment(date);

  if (!convertedDate.isValid()) {
    return null;
  }

  if (convertedDate.isSame(moment().startOf('day'), 'd')) {
    return `${convertedDate.format('HH:mm')} ${translations(messages.today)}`;
  }

  if (convertedDate.isSame(moment().subtract(1, 'days').startOf('day'), 'd')) {
    return `${convertedDate.format('HH:mm')} ${translations(messages.yesterday)}`;
  }
  return `${convertedDate.format('HH:mm')} | ${moment(date).format('DD/MM')}`;
};

export function convertTimestamp(timestamp: number) {
  return moment.unix(timestamp).format('HH:mm DD/MM/YYYY');
}
